(function(){
  document.querySelectorAll('.ee-lp .faq-q').forEach(function(b){
    b.addEventListener('click',function(){
      var it=b.closest('.faq-item'),a=it.querySelector('.faq-a');
      if(it.classList.contains('open')){a.style.maxHeight=null;it.classList.remove('open');}
      else{it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
    });
  });
  var sticky=document.getElementById('stickyCta'),hero=document.querySelector('.ee-lp .hero');
  function onScroll(){ if(!hero)return; var bt=hero.getBoundingClientRect().bottom; if(bt<0)sticky.classList.add('show'); else sticky.classList.remove('show'); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
})();
